/** Matches dashboard `dashboardCompactControlClass` (h-8) with auth dark chrome. */
export const authFieldClassName =
  'h-8 text-sm border-zinc-700/80 bg-zinc-900/60 text-zinc-50 shadow-none placeholder:text-zinc-500 focus-visible:ring-zinc-500'

export const authFormStackClass = 'space-y-3'

export const authFormFieldClass = 'space-y-1.5'

export const authFormHeaderClass = 'mb-8 text-center'

export const authLabelClassName = 'text-zinc-200'

export const authPrimaryButtonClassName =
  'bg-zinc-100 text-zinc-950 shadow-none hover:bg-white'

/** Shared size for a field + submit pair that should read as one balanced unit (same height, radius, type). */
export const authLargeControlClassName = 'h-12 rounded-xl px-4 text-base md:text-base'

/** Large "Continue with …" social sign-in buttons — deliberately bigger than the h-8 form controls. */
export const authSocialButtonClassName =
  'h-14 w-full gap-3 rounded-xl border-zinc-700 bg-zinc-900/40 text-base font-semibold text-zinc-50 shadow-none hover:bg-zinc-800 hover:text-zinc-50 [&_svg]:size-5'
